<template>
  <div id="notice-detail">
    <div v-show="!loading">
      <div class="c-notice-detail__time">
        <span v-if="shopNews && shopNews.discloseAt">{{ formatDateTime(shopNews.discloseAt) }}</span>
        <img v-if="shopNews && shopNews.discloseAt && isNew(new Date(shopNews.discloseAt))" src="/assets/images/icon/icon-new.svg" alt="" />
      </div>
      <div class="c-notice-detail__title">
        {{ shopNews.title }}
      </div>
      <template v-if="shopNews.image && shopNews.image.length > 0">
        <div class="swiper-container js-swiper_announce">
          <div class="swiper-wrapper">
            <div class="c-list-deal__img swiper-slide js-keep-ratio" data-ratio="0.746" v-for="img in shopNews.image" :key="img">
              <img v-bind:src="getImgSrc(img)" alt="" height="100%" width="100%" style="object-fit: contain; background-color: #f0f0f0;">
            </div>
          </div>
        </div>
      </template>
      <div class="swiper-pagination swiper-pagination-announcedetail" v-if="shopNews.image && shopNews.image.length > 1"></div>
      <div class="c-notice-detail__content" v-html="autolink(shopNews.content)">
      </div>
    </div>
    <loader :loading="loading" /> 
    <alert :message="alert_msg" :show="alert_show" :closeModal="closeModal" :confirm_show="confirm_show"
        :confirm_message="confirm_msg" :confirm_callback="confirm_callback" :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel" :label_ok="confirm_label_ok"></alert>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import Swiper, { Pagination } from "swiper";
import {
  getNews,
  getShop
} from "../store/firestore.js";
import loader from "../components/parts/loader.vue";
import Alert from "../components/Alert.vue";

const $ = window.$;

Swiper.use(Pagination);

export default Vue.extend({
  name: "AnnounceDetail",
  props: {
    newsId: {
      type: String,
      required: false
    }
  },
  components: {
    loader,
    alert: Alert
  },
  mixins: [Tenant],
  data() {
    return {
      shopName: "",
      shopNews: {},
      getNews: getNews,
      loading: false
    }
  },
  watch: {
    newsId: {
      handler: async function (newVal) {
        this.loading = true;
        if (newVal) {
          const shopId = Common.getUrlParam('shopId');
          if (!shopId || shopId === this.$store.state.shopId) {
            this.shopNews = await this.getNews(newVal, this.SHOP_ID || this.$store.state.shopId);
          }
        }
        await this.$nextTick();
        new Swiper(".js-swiper_announce", {
          slidesPerView: 1,
          speed: 400,
          direction: "horizontal",
          observer: true,
          observeParents: true,
          waitForTransition: true,
          pagination: {
            el: ".swiper-pagination-announcedetail",
            clickable: true,
          },
        });
        this.loading = false;
        console.log(this.shopNews, 123);
        
      },
      immediate: true
    }
  },
  async created() {
    let shopId = Common.getUrlParam('shopId');
    if (shopId && shopId != this.$store.state.shopId) {
      const shop = await getShop(shopId);
      const res = await this.confirm(`${shop.name}\n\nこの店舗に表示を切り替える`, false, { ok_label: 'はい', cancel_label: 'いいえ' });
      if (res) {
        await this.$store.dispatch('setShopId', shopId);
        location.reload()
      } else {
        this.$router.push('/top');
      }
    }

    this.init();
  },
  mounted() {
    Common.initDom();
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
      $('.c-notice-detail__content a').addClass('ext-link');
    },
  },
  beforeDestroy() {
    this.shopName = "";
    this.shopNews = undefined;
  }
});
</script>